import { useMemo } from 'react';
import { getLogger } from './logger-service';
import type { Logger } from './types';

/**
 * React hook to get the logger instance
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const logger = useLogger();
 *
 *   const handleClick = () => {
 *     logger.info('Button clicked', { buttonId: 'submit' });
 *   };
 *
 *   return <button onClick={handleClick}>Click me</button>;
 * }
 * ```
 */
export function useLogger(): Logger {
  return useMemo(() => getLogger(), []);
}
